import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/cn';

interface GamesGridProps extends PropsWithChildren {
  className?: string;
}

export const GamesGrid = ({ children, className }: GamesGridProps) => (
  <div className={cn('grid grid-cols-3 xsm:grid-cols-[repeat(5,minmax(0,7.5rem))] md:grid-cols-[repeat(6,minmax(0,7.5rem))] sm:justify-start lg:grid-cols-[repeat(5,minmax(0,7.5rem))] content-center xxl:grid-cols-[repeat(6,minmax(0,7.5rem))] gap-x-3.5 sm:gap-x-6 gap-y-4 sm:gap-y-4', className)}>
    {children}
  </div>
);
